import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col } from '@elevationscu/ui-component-lib';
import styles from './ProgressBar.module.scss';

export default function ProgressBar({ pageNumber, maxPages }) {
  const totalPages = 6;
  // eslint-disable-next-line no-unused-vars
  const [title, setTitle] = React.useState(`Request a Rate Proposal - Page ${pageNumber} | Elevations Credit Union`);

  return (
    <Container>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Row
        className={styles.rowStyle}
        tabindex="0"
        role="progressbar"
        aria-valuemax={maxPages}
        aria-valuenow={pageNumber}
        aria-valuetext={`Page ${pageNumber} of ${maxPages}`}
      >
        {Array(totalPages).fill(0).map((value, index) => (
          <Col className={index < pageNumber ? styles.currentProgress : styles.progressStyle}>
            <svg width="250" height="20" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <rect
                className={index < pageNumber ? styles.currentProgressSvg : styles.emptyProgressSvg}
                x="0"
                y="0"
                width="250"
                height="13"
              />
            </svg>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
